import api from '@lib/api'
import type { ResourceType } from '@orbit/api-types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { invalidateFileResource } from './fileResource'

interface DeleteFileVars {
	tripId: string
	fileId: string
	/** The kind of entity the file hangs off, so its `fileIds` refetch too. */
	resourceType?: ResourceType
}

export function useDeleteFile() {
	const queryClient = useQueryClient()

	return useMutation<void, Error, DeleteFileVars>({
		mutationFn: async ({ tripId, fileId }) => {
			await api.delete(`/trips/${tripId}/files/${fileId}`)
		},
		onSuccess: (_data, { tripId, resourceType }) => invalidateFileResource(queryClient, tripId, resourceType),
	})
}
